const palette = {
  common: {
    black: '#000000',
    white: '#ffffff',
  },
  primary: {
    light: '#e8eaf6',
    main: '#3f51b5',
    dark: '#3949ab',

  },
  secondary: {
    light: '#e8eaf6',
    main: '#3f51b5',
    dark: '#3949ab',

  },
  orange: {
    '100': '#f28758',
  },
  grey: {
    '40': '#ffffffb3',
    '50': '#ffffff33',
    '60': '#ffffff0d',
    '70': '#f6f6fa',
    '100': '#eef2f6',
    '150': '#eaeaea',
    '200': '#dee0e7',
    '250': '#dedede',
    '300': '#b4b8bc',
    '400': '#999999',
    '500': '#959595',
    '540': '#929292',
    '550': '#817e7e',
    '600': '#7f7f7f',
    '650': '#736e6e',
    '700': '#697586',

  },
  text: {
    primary: '#000000',
    secondary: '#697586',
    dark: '#121926',
    hint: '#eef2f6',
  },
  blue: {
    '30': '#f8fbff',
    '40': '#e0ebff',
    '41': '#edf3f8',
    '42': '#e9f0ff',
    '45': '#e1ecff',
    '50': '#e3edff',
    '51': '#e8f0ff', // Used as tabs bg
    '55': '#7da0c0',
    '60': '#afc5d9',
    '70': '#c7dbed',
    '75': '#c2d5ff',
    '80': '#9fc4e6',
    '100': '#d2e1fc',
    '120': '#1E90FF26',
    '200': '#bfd6ff',
    '300': '#6396f0',
    '325': '#5992f9', // Used as tag bg inside selected tab
    '350': '#114ebd',
    '400': '#1450be',
    '500': '#3172e8',
    '600': '#3679f1',
    '700': '#1200ff',
    '900': '#061220',
  },
  red: {
    '100': '#f0d2d2',
    '110': '#ffe1dd',
    '150': '#fbc5be',
    '200': '#b51f1f',
    '300': '#d23333',
    '400': '#fc0007',
    '500': '#fb0006',
  },
  green: {
    '100': '#cedfce',
    '400': '#085e08',
  },
  yellow: {
    hover: '#ffcb72',
    '100': '#fff9ef',
    '150': '#ffeeaa',
    '200': '#fde9c8',
    '300': '#ffd47e',
    '400': '#f4a201',
  },
  inputs: {
    defaultPrimary: '#a0a8c4',
    defaultSecondary: '#33384d',
    hoverPrimary: '#6396F0',
    hoverSecondary: '#0A3177',
    disabled: '#d3dee8',
    disabledText: '#5d647a',
    reactionFocused: '#d0e1ff',
    yellow: '#ffeeaa',
    yellowFocused: '#ffcb72',
    yellowFocusedBorderPrimary: '#e89802',
    yellowFocusedBorderSecondary: '#b65f0e',
  },
};


export default palette;
